import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { ConditionalWrapper } from '@as/cotopaxi';
import { makeGetProductBrand } from '../redux/product/selectors/ProductSelector';
import RelatedCategories from '../components/related-categories/RelatedCategories';
const RelatedCategoriesContainer = ({ crumbs = [], title, analyticsBannerId, }) => {
    const brand = useSelector(makeGetProductBrand());
    return (_jsx(ConditionalWrapper, { condition: Boolean(analyticsBannerId), wrapper: children => _jsx("div", { "data-analytics-bannerid": analyticsBannerId, children: children }), children: _jsx(RelatedCategories, { categories: crumbs, brand: brand, title: title }) }));
};
export default RelatedCategoriesContainer;
